export default {
  methods: {
    notifySuccess (message) {
      this.$notify({
        group: "notices",
        type: "success",
        text: message
      });
    },

    notifyErrors (messages) {
      messages.forEach(errorMessage =>
        this.notifyError(errorMessage)
      );
    },

    notifyError (message) {
      this.$notify({
        group: "notices",
        type: "error",
        text: message
      });
    }
  }
};
